import { type ReactNode } from 'react';
import { Alert as MantineAlert } from '@mantine/core';
import type { AlertProps as MantineAlertProps } from '@mantine/core';
import './Alert.css';

export type AlertTone = 'error' | 'success' | 'info' | 'warning';

export interface AlertProps extends Omit<MantineAlertProps, 'color' | 'variant'> {
  tone?: AlertTone;
  children: ReactNode;
}

const TONE_TO_COLOR: Record<AlertTone, MantineAlertProps['color']> = {
  error: 'red',
  success: 'teal',
  info: 'blue',
  warning: 'yellow',
};

export default function Alert({
  tone = 'error',
  className = '',
  children,
  radius = 'md',
  ...props
}: AlertProps) {
  return (
    <MantineAlert
      className={`app-alert app-alert--${tone} ${className}`.trim()}
      color={TONE_TO_COLOR[tone]}
      variant="light"
      radius={radius}
      {...props}
    >
      {children}
    </MantineAlert>
  );
}
